import { useEffect, useState } from "react";
import { useWebSocket } from "react-use-websocket/dist/lib/use-websocket";
import { io } from "socket.io-client";

const socketType = process.env.REACT_APP_SOCKET_TYPE;

const socket = io(process.env.REACT_APP_IRAN_SOCKET_URL, { transports: ["websocket"] });

const useStateQuery = (cryptoPair, timeInterval) => {
  const [liveResult, setLiveResult] = useState({});
  const [websocketInfo, setWebsocketInfo] = useState({
    repeats: 0,
    success: 0,
  });
  const [shouldUseWebSocket, setShouldUseWebSocket] = useState(true);

  const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket(
    socketType !== "iran" ? process.env.REACT_APP_GERMANY_SOCKET_URL : null,
    {
      onOpen: (e) => {},
      //Will attempt to reconnect on all close events, such as server shutting down
      onMessage: (e) => {},
      shouldReconnect: (closeEvent) => {
        return true;
      },
      pingTimeout: 1000,
      share: true,
      pingMessage:
        socketType === "iran"
          ? undefined
          : JSON.stringify({
              method: "server.ping",
              params: [],
              id: 11,
            }),
    }
  );

  const handleDisconnect = () => {
    socket.connect();
  };

  useEffect(() => {
    if (socketType === "iran") {
      socket.on("connect", () => {
        if (socket.connected) {
          socket.emit(
            "state",
            JSON.stringify({
              type: "state",
              market_pair: cryptoPair.toUpperCase(),
            })
          );
        }
      });
      socket.on("state", (data) => {
        const response = JSON.parse(data);

        setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
        const date = new Date();
        const now = date.getTime();
        const { result } = response;
        // console.log(result)
        if (
          +result?.open === 0 &&
          +result?.close === 0 &&
          +result?.high === 0 &&
          +result?.low === 0
        ) {
          setLiveResult({
            time: Math.floor(now / 1000 / timeInterval) * timeInterval,
          });
        } else {
          setLiveResult({
            ...result,
            time: Math.floor(now / 1000 / timeInterval) * timeInterval,
          });
        }
      });
      socket.on("disconnect", handleDisconnect);

      return () => {
        socket.off("connect");
        socket.off("state");
      };
    }
  }, [timeInterval, cryptoPair]);

  useEffect(() => {
    if (socketType !== "iran") {
      let interval = null;
      if (readyState === 1) {
        interval = setInterval(() => {
          const date = new Date();
          const now = date.getTime();
          const timePeriod =
            Math.floor(now / 1000) - Math.floor(now / 1000 / timeInterval) * timeInterval;

          setWebsocketInfo((prev) => ({ ...prev, repeats: prev.repeats + 1 }));
          sendJsonMessage({
            method: "state.query",
            params: [cryptoPair, timePeriod],
            id: 15,
          });
        }, 1000);
      } else if (readyState === 3) {
        setShouldUseWebSocket(false);
      }
      return () => socketType !== "iran" && clearInterval(interval);
    }
  }, [readyState, timeInterval, cryptoPair]);

  useEffect(() => {
    if (lastJsonMessage !== null) {
      if (socketType === "iran") {
        if (lastJsonMessage.type === "state" && !lastJsonMessage.error) {
          console.log(lastJsonMessage.result);
          setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
          const date = new Date();
          const now = date.getTime();

          const { result } = lastJsonMessage;
          if (
            +result?.open === 0 &&
            +result?.close === 0 &&
            +result?.high === 0 &&
            +result?.low === 0
          ) {
            setLiveResult({
              time: Math.floor(now / 1000 / timeInterval) * timeInterval,
            });
          } else {
            setLiveResult({
              ...result,
              time: Math.floor(now / 1000 / timeInterval) * timeInterval,
            });
          }
        }
      } else {
        if (lastJsonMessage.id === 15) {
          setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
          const date = new Date();
          const now = date.getTime();

          const { result } = lastJsonMessage;
          if (
            +result?.open === 0 &&
            +result?.close === 0 &&
            +result?.high === 0 &&
            +result?.low === 0
          ) {
            setLiveResult({
              time: Math.floor(now / 1000 / timeInterval) * timeInterval,
            });
          } else {
            setLiveResult({
              ...result,
              time: Math.floor(now / 1000 / timeInterval) * timeInterval,
            });
          }
        }
      }
    }
  }, [lastJsonMessage]);

  useEffect(() => {
    const { repeats, success } = websocketInfo;
    const errorRate = (repeats - success) / repeats;
    if (repeats > 20 && errorRate > 0.3 && shouldUseWebSocket === true) {
      setShouldUseWebSocket(false);
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
    const successRate = success / repeats;
    if (repeats > 20 && successRate >= 0.7 && shouldUseWebSocket === false) {
      setShouldUseWebSocket(true);
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
    if (repeats > 30) {
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
  }, [websocketInfo]);

  // اطلاعات هر کندل اینجا میگیره
  return { liveResult, shouldUseWebSocket, cryptoPair };
};
export default useStateQuery;
